import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { invoiceService } from '../services/invoiceService';
import type { Invoice } from '@clinic-os/shared/types';

export const INVOICES_KEY = ['invoices'] as const;

export function useInvoices() {
  return useQuery({
    queryKey: INVOICES_KEY,
    queryFn: () => invoiceService.getAll(),
  });
}

export function useInvoice(id: string) {
  return useQuery({
    queryKey: [...INVOICES_KEY, id],
    queryFn: () => invoiceService.getById(id),
    enabled: !!id,
  });
}

export function useOutstanding() {
  return useQuery({
    queryKey: [...INVOICES_KEY, 'outstanding'],
    queryFn: () => invoiceService.getOutstanding(),
  });
}

export function useCreateInvoice() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: Omit<Invoice, 'id' | 'createdAt' | 'updatedAt'>) => invoiceService.create(data),
    onSuccess: () => qc.invalidateQueries({ queryKey: INVOICES_KEY }),
  });
}

export function useMarkInvoicePaid() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => invoiceService.markPaid(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: INVOICES_KEY }),
  });
}
